<script setup lang="ts">
import { computed } from "vue";
import { useClaimStore } from "@/store";
import ClaimTimelineElement from './ClaimTimelineElement.vue'
import BaseButton from "../ui/buttons/BaseButton.vue";
import { BellAlertIcon } from "@heroicons/vue/24/solid";
import { sort } from "ramda";

const claimEvents = computed(() => {
  const { claim } = useClaimStore();
  const events = sort((a, b) => {
    const eventDateA = new Date(a.eventDate).getTime();
    const eventDateB = new Date(b.eventDate).getTime();

    if (eventDateA === eventDateB) {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    }

    return eventDateB - eventDateA;
  }, claim?.claimEvents || [])
  return events;
});
</script>
<template>
<div class="block">
  <section aria-labelledby="timeline-title">
    <div class="max-w-full">
      <div class="flex flex-col">
        <div class="align-middle shadow sm:rounded-lg">
          <div class="divide-y divide-gray-200 ">
            <div colspan="2" class="px-6 py-5 text-left bg-white">
              <div>
                <h2 class="text-xl font-medium leading-6 text-gray-900">
                  Timeline
                </h2>
                <p class="max-w-2xl mt-1 text-sm font-normal text-gray-500">
                  Les derniers éléments de votre dossier.
                </p>
              </div>
              <div class="mt-2">
                <BaseButton size="lg" text="M'abonner aux alertes" :icon="BellAlertIcon" />
              </div>
            </div>
              <!-- <tr>
                <th id="timeline" class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50">
                  Test
                </th>
                <th class="px-6 py-3 text-xs font-medium tracking-wider text-right text-gray-500 uppercase bg-gray-50">
                  Date
                </th>
              </tr> -->
              <div class="px-5">
                <ol class="relative w-full text-left border-l border-gray-200">
                <ClaimTimelineElement
                  v-for="(event, index) of claimEvents"
                  v-bind:key="event.id"
                  :previous-event="claimEvents[index + 1]"
                  :event="event"
                  :index="index"
                  :timelineLength="claimEvents.length"
                />
              </ol>
              </div>

              
              <!-- More items... -->
          </div>
          <!-- Pagination -->
          <nav class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6" aria-label="Pagination">
            <div class="hidden sm:block">
              <p class="text-sm text-gray-700">
                Showing
                <span class="font-medium">{{claimEvents.length}}</span>
                to
                <span class="font-medium">10</span>
                of
                <span class="font-medium">20</span>
                results
              </p>
            </div>
            <div class="flex justify-between flex-1 sm:justify-end">
              <a href="#" class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                Previous
              </a>
              <a href="#" class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                Next
              </a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>
</div>
</template>